import graphqlClient from "../../../apollo";

class DailyBoxProvider {

    findDailyBox(id) {
        return graphqlClient.query({
            query: require('./gql/DailyBox/findDailyBox.graphql'),
            variables: {id:id},
            fetchPolicy: "network-only"
        })
    }

    findDailyBoxByDateAndShift(date, shift) {
        return graphqlClient.query({
            query: require('./gql/DailyBox/findDailyBoxByDateAndShift.graphql'),
            variables: {date, shift},
            fetchPolicy: "no-cache"
        })
    }

    findPreviousDailyBoxByDateAndShift(date, shift) {
        return graphqlClient.query({
            query: require('./gql/DailyBox/findPreviousDailyBoxByDateAndShift.graphql'),
            variables: {date, shift},
            fetchPolicy: "no-cache"
        })
    }


    paginateDailyBox(pageNumber, itemsPerPage, search = null, filters = null,  orderBy = null, orderDesc = false) {
        return graphqlClient.query({
            query: require('./gql/DailyBox/paginateDailyBox.graphql'),
            variables: {pageNumber, itemsPerPage, search, filters, orderBy, orderDesc},
            fetchPolicy: "network-only"
        })
    }



    createDailyBox(input) {
        return graphqlClient.mutate({
            mutation: require('./gql/DailyBox/createDailyBox.graphql'),
            variables: {input}
        })
    }

    createOrUpdateDailyBox(input) {
        return graphqlClient.mutate({
            mutation: require('./gql/DailyBox/createOrUpdateDailyBox.graphql'),
            variables: {input}
        })
    }

    updateDailyBox(id,input) {
        return graphqlClient.mutate({
            mutation: require('./gql/DailyBox/updateDailyBox.graphql'),
            variables: {id, input}
        })
    }

     deleteDailyBox(id) {
        return graphqlClient.mutate({
            mutation: require('./gql/DailyBox/deleteDailyBox.graphql'),
            variables: {id}
        })
    }

}

export default new DailyBoxProvider()


